import AiHead from '../../assets/checker/aihead.svg';

export default function AboutSection() {
  return (
    <section className='min-h-screen w-full bg-[#F5F5F5] flex items-center justify-center px-4 md:px-6 lg:px-10 py-16 md:py-20 lg:py-24'>
      <div className='max-w-[1400px] w-full'>
        <div className='flex flex-col lg:flex-row items-center gap-12 lg:gap-16 xl:gap-20'>
          {/* Left Content - AI Head Image */}
          <div className='w-full lg:w-1/2 flex justify-center lg:justify-start'>
            <div className='w-full max-w-[500px] lg:max-w-none'>
              <img 
                src={AiHead} 
                alt='AI Head Illustration' 
                className='w-full h-auto'
              />
            </div>
          </div>

          {/* Right Content - Text */}
          <div className='w-full lg:w-1/2 text-center lg:text-left'>
            <h2 className='text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-8 md:mb-10'>
              About Podus Checker
            </h2>
            
            <div className='space-y-6 md:space-y-8'>
              <p className='text-gray-700 text-base md:text-lg leading-relaxed'>
                Podus Checker is a branch of the Podus AI ecosystem, dedicated to workplace trust and transparency. We believe that every employer deserves peace of mind — and every verified employee deserves the opportunity to prove their integrity.
              </p>
              
              <div className='pt-2'>
                <p className='text-gray-700 text-base md:text-lg leading-relaxed'>
                  Our mission is simple: <span className='font-bold text-gray-900'>to make background checks easy, accurate, and accessible for every organization.</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
